// Visionneuse de photos : un clic sur un lien [data-mq-photo] ouvre la photo en grand dans une boîte modale.
// Zoom : clic ou double-tap sur la photo, boutons + et −, molette ; photo agrandie : on la déplace en la faisant
// glisser (souris) ou défiler (doigt). Flèches et boutons : photo précédente ou suivante du même groupe
// (data-mq-photo="nom du groupe"). Échap ou clic hors de la photo : fermer. Sans JavaScript, le lien ouvre l'image.
const boite = document.querySelector('[data-mq-visionneuse]');
if (boite && typeof boite.showModal === 'function') {
  const cadre = boite.querySelector('[data-vz-cadre]');
  const image = boite.querySelector('[data-vz-image]');
  const legende = boite.querySelector('[data-vz-legende]');
  const compteur = boite.querySelector('[data-vz-compteur]');
  const ZOOMS = [1, 2, 3.5];
  let groupe = [];
  let indice = 0;
  let zoom = 0;
  let origine = null;

  const appliquerZoom = (niveau, px = 0.5, py = 0.5) => {
    zoom = Math.max(0, Math.min(ZOOMS.length - 1, niveau));
    const z = ZOOMS[zoom];
    boite.classList.toggle('vz--zoom', z > 1);
    image.style.width = z > 1 ? `${z * 100}%` : '';
    image.style.height = z > 1 ? 'auto' : '';
    image.style.maxWidth = z > 1 ? 'none' : '';
    image.style.maxHeight = z > 1 ? 'none' : '';
    // le point visé reste sous le pointeur
    cadre.scrollLeft = px * image.offsetWidth - cadre.clientWidth / 2;
    cadre.scrollTop = py * image.offsetHeight - cadre.clientHeight / 2;
    boite.querySelector('[data-vz-moins]').disabled = zoom === 0;
    boite.querySelector('[data-vz-plus]').disabled = zoom === ZOOMS.length - 1;
  };

  const montrer = (i) => {
    indice = (i + groupe.length) % groupe.length;
    const lien = groupe[indice];
    const vignette = lien.querySelector('img');
    appliquerZoom(0);
    image.src = lien.dataset.mqPhotoSrc || lien.href;
    image.alt = vignette ? vignette.alt : '';
    legende.textContent = image.alt;
    compteur.textContent = `${String(indice + 1).padStart(2, '0')} / ${String(groupe.length).padStart(2, '0')}`;
    const seul = groupe.length < 2;
    boite.querySelector('[data-vz-precedente]').hidden = seul;
    boite.querySelector('[data-vz-suivante]').hidden = seul;
  };

  document.addEventListener('click', (evt) => {
    const lien = evt.target.closest && evt.target.closest('a[data-mq-photo]');
    if (!lien || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button > 0) return;
    evt.preventDefault();
    origine = lien;
    groupe = [...document.querySelectorAll(`a[data-mq-photo="${lien.dataset.mqPhoto}"]`)];
    boite.showModal();
    montrer(groupe.indexOf(lien));
  });

  boite.querySelector('[data-vz-fermer]').addEventListener('click', () => boite.close());
  boite.querySelector('[data-vz-precedente]').addEventListener('click', () => montrer(indice - 1));
  boite.querySelector('[data-vz-suivante]').addEventListener('click', () => montrer(indice + 1));
  boite.querySelector('[data-vz-plus]').addEventListener('click', () => appliquerZoom(zoom + 1));
  boite.querySelector('[data-vz-moins]').addEventListener('click', () => appliquerZoom(zoom - 1));
  boite.addEventListener('close', () => {
    image.removeAttribute('src');
    if (origine) origine.focus({ preventScroll: true });
  });
  boite.addEventListener('keydown', (evt) => {
    if (evt.key === 'ArrowLeft') montrer(indice - 1);
    else if (evt.key === 'ArrowRight') montrer(indice + 1);
    else if (evt.key === '+' || evt.key === '=') appliquerZoom(zoom + 1);
    else if (evt.key === '-') appliquerZoom(zoom - 1);
  });

  // clic sur la photo : zoom sur le point cliqué, puis retour ; clic sur le fond : fermer. Un glissé n'est pas un clic.
  let glisse = null;
  let aBouge = false;
  let surPhoto = false;
  cadre.addEventListener('pointerdown', (evt) => {
    aBouge = false;
    // retenu ici : une fois le pointeur capturé pour le glissé, le clic ne vise plus la photo mais le cadre
    surPhoto = evt.target === image;
    if (evt.pointerType !== 'mouse' || zoom === 0 || evt.button > 0) return;
    glisse = { x: evt.clientX, y: evt.clientY, gauche: cadre.scrollLeft, haut: cadre.scrollTop };
    cadre.setPointerCapture(evt.pointerId);
  });
  cadre.addEventListener('pointermove', (evt) => {
    if (!glisse) return;
    const dx = evt.clientX - glisse.x;
    const dy = evt.clientY - glisse.y;
    if (Math.abs(dx) + Math.abs(dy) > 4) aBouge = true;
    cadre.scrollLeft = glisse.gauche - dx;
    cadre.scrollTop = glisse.haut - dy;
  });
  const lacher = () => { glisse = null; };
  cadre.addEventListener('pointerup', lacher);
  cadre.addEventListener('pointercancel', lacher);
  cadre.addEventListener('click', (evt) => {
    if (aBouge) return;
    if (!surPhoto && evt.target !== image) { boite.close(); return; }
    const r = image.getBoundingClientRect();
    const px = (evt.clientX - r.left) / r.width;
    const py = (evt.clientY - r.top) / r.height;
    appliquerZoom(zoom === ZOOMS.length - 1 ? 0 : zoom + 1, px, py);
  });
  cadre.addEventListener('wheel', (evt) => {
    if (!evt.ctrlKey && zoom > 0) return; // photo agrandie : la molette la fait défiler
    evt.preventDefault();
    const r = image.getBoundingClientRect();
    appliquerZoom(zoom + (evt.deltaY < 0 ? 1 : -1), (evt.clientX - r.left) / r.width, (evt.clientY - r.top) / r.height);
  }, { passive: false });
}
